export default __webpack_public_path__ + "static/media/shop-light.9ef20812.svg";